import type {
  GetMyAcknowledgementResponse,
  GetMyAcknowledgementsResponse,
  GetMyAcknowledgementSummaryResponse,
} from '@gokrew/models/esignature';
import api from './client';

const endpoints = {
  list: '/employee/acknowledgements',
  summary: '/employee/acknowledgements/summary',
  one: (id: string) => `/employee/acknowledgements/${id}`,
  confirm: (id: string) => `/employee/acknowledgements/${id}/confirm`,
};

/** My documents to read, pending first. */
export async function getMyAcknowledgements(
  status?: 'pending' | 'acknowledged'
) {
  const { data } = await api.get<GetMyAcknowledgementsResponse>(
    endpoints.list,
    { params: status ? { status } : undefined }
  );
  return data;
}

/** How many I still have to read (the nav badge). */
export async function getMyAcknowledgementSummary() {
  const { data } = await api.get<GetMyAcknowledgementSummaryResponse>(
    endpoints.summary
  );
  return data;
}

/** One document, with its text. The first open is recorded. */
export async function getMyAcknowledgement(id: string) {
  const { data } = await api.get<GetMyAcknowledgementResponse>(
    endpoints.one(id)
  );
  return data;
}

/**
 * "I have read and understood this document" (or a form's Submit). The hash
 * proves the confirmation is about the exact text shown; `answers` are the
 * fields the person filled in, checked by the server.
 */
export async function confirmAcknowledgement(
  id: string,
  contentSha256: string,
  answers?: Record<string, unknown>
) {
  const { data } = await api.post<GetMyAcknowledgementResponse>(
    endpoints.confirm(id),
    { confirmed: true, contentSha256, ...(answers ? { answers } : {}) }
  );
  return data;
}
